import { render, staticRenderFns } from "./CordinatorCertificate.vue?vue&type=template&id=75a2bdca&scoped=true"
import script from "./CordinatorCertificate.vue?vue&type=script&lang=js"
export * from "./CordinatorCertificate.vue?vue&type=script&lang=js"
import style0 from "./CordinatorCertificate.vue?vue&type=style&index=0&id=75a2bdca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a2bdca",
  null
  
)

export default component.exports